import React from 'react';
import { reduxForm } from 'redux-form';
// import logocover from '@assets/img/illustrations/logocover.png';
import { Formik, Field, Form } from 'formik';
import cn from 'classnames';
import EN from '@localization/EN';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import topLogo from '@assets/img/illustrations/client_logo.png';
import styles from './index.module.css';

const UNLoginPage = (props) => {
  return (
    <div className={cn(styles.loginbody)}>
      <div className="pt-48">
        <div className="offset-md-1 col-md-10 pl-4 pl-md">
          <img src={topLogo} className={cn(styles.topLogo)} alt="..." />
        </div>
      </div>
      <div className="pt-48 pb-48 px-2">
        <div className="offset-md-3 col-md-6 card">
          <div className="offset-md-2 col-md-8 pt-48 pb-48">
            <div className={cn(styles.headerBox)}>
              <img src={topLogo} className={cn('', styles.formLogo)} alt="..." />
              <h1 className={cn(styles.heading)}>
                {EN.WELCOME}
              </h1>
              <p className="text-center mb-5">
                {EN.NO_ACCOUNT}
                <a href="/users/signup">
                  <u>
                    {EN.Signup}
                  </u>
                </a>
              </p>
            </div>
            <div className={cn(styles.form)}>
              <Formik
                initialValues={{
                  userName: '',
                  password: ''
                }}
                validationSchema={Yup.object().shape({
                  userName: Yup.string().email('Invalid email format').required(EN.EMAIL_ADDRESS_REQUIRED).min(3, EN.MIN_LENGTH),
                  password: Yup.string().required(EN.PASS_VALIDATION)
                })}
                onSubmit={(values) => {
                  props.handleSubmit(values);
                }}
              >
                {({ touched, errors, handleChange }) => (
                  <Form>
                    {props && props.errmsg && (
                    <div className="alert alert-danger" style={{ textAlign: 'left', backgroundColor: 'red', color: 'white' }} role="alert">
                      <p>
                        {props.errorDescription}
                      </p>
                    </div>
                    ) }
                    <div className="form-group" style={{ textAlign: 'left' }}>
                      <label htmlFor="Username">
                        {EN.EMAIL_TEXT}
                      </label>
                      <Field
                        type="Text"
                        name="userName"
                        onChange={handleChange('userName')}
                        placeholder="Enter your email"
                        className={cn(`form-control textBox ${
                          errors.userName ? 'is-invalid' : ''
                        }`, styles.textBox)}
                      />
                      {touched.userName && errors.userName && (
                      <span className="error">
                        {errors.userName}
                      </span>
                      )}
                    </div>
                    <div className="form-group">
                      <div className="row">
                        <div className="col-6" style={{ textAlign: 'left' }}>
                          <label htmlFor="Password">
                            {EN.Password}
                          </label>
                        </div>
                      </div>

                      <div className="input-group input-group-merge">
                        <input
                          type={props.showText ? 'text' : 'password'}
                          name="password"
                          onChange={handleChange('password')}
                          placeholder="Enter your password"
                          className={cn(`form-control border-right-0 form-control-appended ${
                            errors.password ? 'is-invalid' : ''
                          }`, styles.textBox)}
                        />
                        <div className="input-group-append">
                          <span className={cn('input-group-text', styles.icon)}>

                            <i className="fe fe-lock cursor-pointer" onClick={() => { props.ontoggleClickLock(); }} role="presentation" />
                          </span>
                        </div>
                      </div>
                      {touched.password && errors.password && (
                      <span className="error">
                        {errors.password}
                      </span>
                      )}
                    </div>
                    <button
                      type="submit"
                      className={cn(styles.submitButton)}
                    >
                      {EN.LOG_IN}
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
            <div className={cn(styles.forgotPassword)}>
              <Link className="form-text" to="/forgotpassword">
                <u>
                  {EN.Forgotpassword}
                </u>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default reduxForm({
  form: 'LoginPage', // a unique identifier for this form
})(UNLoginPage);
